import { Heading } from '../Heading/Heading';
import { HasStyle } from '~/types/HasStyle';
import { PropsWithChildren } from 'react';
import styles from './Dialog.module.css';
import {
  DialogBackdrop as HUIDialogBackdrop,
  DialogPanel as HUIDialogPanel,
  Dialog as HUIDialog,
} from '@headlessui/react';

export type Props = PropsWithChildren &
  HasStyle & {
    onClose: () => void;
    isOpen: boolean;
  };

// eslint-disable-next-line react-refresh/only-export-components
function DialogElement({ children, isOpen, onClose }: Props) {
  return (
    <HUIDialog open={isOpen} onClose={onClose}>
      <HUIDialogBackdrop className={styles.backdrop} transition />

      <div className={styles.container}>
        <HUIDialogPanel className={styles.dialog} transition>
          {children}
        </HUIDialogPanel>
      </div>
    </HUIDialog>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
function Title({ children }: PropsWithChildren) {
  return (
    <Heading as="h3" className={styles.title}>
      {children}
    </Heading>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
function Text({ children }: PropsWithChildren) {
  return <p>{children}</p>;
}

export const Dialog = Object.assign(DialogElement, {
  Title,
  Text,
});
